// Filter for names and text that other players see (leaderboards, duel
// opponents, notifications, topic suggestions). Not a full moderation system:
// it stops the obvious slurs and profanity, including l33t spellings,
// stretched letters ("fuuuck") and run-together words ("BigDick"), without
// tripping on real names like Kshitij, Cassandra or Dickens.
// Distinctive enough to block anywhere inside a name.
const ANYWHERE = [
    'fuck', 'cunt', 'nigger', 'nigga', 'faggot', 'motherfucker', 'asshole', 'dickhead', 'bullshit',
    'whore', 'slut',
    // Hindi / Hinglish
    'madarchod', 'maderchod', 'bhenchod', 'behenchod', 'bhosdi', 'bhosadi', 'bhosri', 'chutiya', 'chutiye', 'chutia',
    'chodu', 'gaandu', 'jhaatu', 'jhatu',
];
// Only blocked as a whole word (they appear inside innocent words and names).
const WHOLE_WORDS = new Set([
    'shit', 'shitty', 'shite', 'ass', 'arse', 'bitch', 'bitches', 'bastard', 'dick', 'dicks', 'cock', 'cocks',
    'pussy', 'cum', 'tits', 'titties', 'boobs', 'penis', 'vagina', 'porn', 'porno', 'sex', 'rape', 'raped',
    'nazi', 'hitler', 'fag', 'fags', 'retard', 'kys', 'rapist', 'wank', 'wanker', 'negro', 'paki', 'chink', 'spic', 'kike', 'tranny',
    // Hindi / Hinglish
    'gandu', 'randi', 'lund', 'lauda', 'lavda', 'loda', 'lodu', 'chut', 'harami', 'bsdk',
]);
// Real places/words that contain an ANYWHERE term.
const ALLOWED = ['scunthorpe'];
const LEET = {
    '0': 'o', '1': 'i', '!': 'i', '|': 'i', '3': 'e', '4': 'a', '@': 'a', '5': 's', '$': 's', '7': 't', '8': 'b', '9': 'g',
};
// "fuuuuck" -> "fuck" and "asss" -> "ass": try both collapses of 3+ repeats.
const collapse = (s) => [s.replace(/(.)\1{2,}/g, '$1'), s.replace(/(.)\1{2,}/g, '$1$1')];
export function isOffensive(text) {
    const spaced = text.replace(/([a-z])([A-Z])/g, '$1 $2'); // BigDick -> Big Dick
    const lowered = spaced.toLowerCase().normalize('NFKD').replace(/[̀-ͯ]/g, '');
    const mapped = [...lowered].map(c => LEET[c] ?? c).join('');
    let joined = mapped.replace(/[^a-z]/g, '');
    for (const ok of ALLOWED)
        joined = joined.split(ok).join('');
    if (collapse(joined).some(j => ANYWHERE.some(term => j.includes(term))))
        return true;
    const tokens = mapped.split(/[^a-z]+/).filter(Boolean);
    return tokens.some(t => collapse(t).some(v => WHOLE_WORDS.has(v)));
}
// A display name as stored and shown to others: tidied, max 20 characters,
// or null (shown as "Mystery Player"/"Anonymous") if empty or offensive.
export function cleanPublicName(name, max = 20) {
    const cleaned = name
        ?.replace(/[\u0000-\u001F\u007F​-‏‪-‮⁠-⁤﻿]/g, '')
        .replace(/\s+/g, ' ')
        .trim()
        .slice(0, max);
    if (!cleaned || isOffensive(cleaned))
        return null;
    return cleaned;
}
